import { render } from "./DraggableBlockComponent.vue?vue&type=template&id=c103e286&scoped=true"
import script from "./DraggableBlockComponent.vue?vue&type=script&lang=js"
export * from "./DraggableBlockComponent.vue?vue&type=script&lang=js"

import "./DraggableBlockComponent.vue?vue&type=style&index=0&id=c103e286&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c103e286"

export default script